import {Component, OnInit, OnDestroy} from '@angular/core';
import {LoginService} from '../login/login.service';

import {Empresa} from '../empresa/empresa';
import {Sucursal} from '../sucursal/sucursal';
import {Ubicacion} from '../ubicacion/ubicacion';

import {EmpresaService} from '../empresa/empresa.service';
import {RegAlarmaService} from '../regAlarma/regAlarma.service';
import {NodoService} from '../nodo/nodo.service';

import * as io from "socket.io-client";
import myGlobals = require('../config');
import {DateTimeZonePipe} from "../pipes/dateTimeZonePipe";
import moment = require("moment");


declare var $: any;

@Component({
    selector: 'home',
    template: require('../../app/homeTecnico/homeTecnico.component.html'),
    styles: [require('../../app/homeTecnico/homeTecnico.component.css')],
    pipes: [DateTimeZonePipe]
})

export class HomeTecnicoComponent implements OnInit, OnDestroy {
    usuario = '';
    sucursales: Sucursal[];
    sucursalSeleccionada: Sucursal;
    socket: any;
    socketSensor: any;
    usuarioConectado: any;
    mostrarTodo: boolean;

    constructor(private regAlarmaService: RegAlarmaService,
                private nodoService: NodoService,
                private loginService: LoginService) {
        this.mostrarTodo = false;
    }

    ngOnDestroy() {
        this.socket.disconnect();
        this.socketSensor.disconnect();
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        this.sucursalSeleccionada = new Sucursal();
        this.usuarioConectado = this.loginService.getDecodeToken();

        //Desactivar auto slide
        $("#myCarousel").carousel({
            interval: false
        });

        //Conectar al socket con configuración específica
        this.socket = io.connect(myGlobals.default.URL_MQTT_ALARMAS, { 
            path: myGlobals.default.PATH_MQTT_ALARMAS,
            transports: ['websocket', 'polling'], // Priorizar websocket
            upgrade: true,
            rememberUpgrade: true
        });
        
        this.socketSensor = io.connect(myGlobals.default.URL_MQTT, { 
            path: myGlobals.default.PATH_MQTT,
            transports: ['websocket', 'polling'], // Priorizar websocket
            upgrade: true,
            rememberUpgrade: true
        });

        // Debug de conexiones
        this.socket.on('connect', () => {
            console.log('Socket alarmas conectado via:', this.socket.io.engine.transport.name);
            this.socket.io.engine.on('upgrade', () => {
                console.log('Socket alarmas actualizado a:', this.socket.io.engine.transport.name);
            });
        });

        this.socketSensor.on('connect', () => {
            console.log('Socket sensor conectado via:', this.socketSensor.io.engine.transport.name);
            this.socketSensor.io.engine.on('upgrade', () => {
                console.log('Socket sensor actualizado a:', this.socketSensor.io.engine.transport.name);
            });
        });

        this.inicializarSocketAlarma();

        //Cargar arbol
        this.recargar();
    }

    private recargar() {
        //Arbol de sucursales->ubicaciones->nodos->sensores segun usuario logueado
        this.nodoService.getNodosInfoBasica().subscribe(
            sucursalesConTodo => {

                this.sucursales = sucursalesConTodo;
                for (let s = 0; s < this.sucursales.length; s++) {
                    let sucursal = this.sucursales[s];
                    if (this.sucursalSeleccionada && this.sucursalSeleccionada._id && this.sucursalSeleccionada._id == sucursal._id)
                        this.sucursalSeleccionada = sucursal;
                    sucursal.alarmaSinActividadActiva = false;
                    sucursal.alarmaActiva = false;
                    sucursal.alarmaBateriaBajaActiva = false;
                    sucursal.alarmaSensorNullActivo = false;
                    sucursal.nodoMantenimiento = false;
                    if (!sucursal.estado) {
                        this.sucursales.splice(this.sucursales.indexOf(sucursal), 1);
                        s--;
                        continue;
                    }
                    for (let u = 0; u < sucursal.ubicaciones.length; u++) {
                        let ubicacion = sucursal.ubicaciones[u];
                        if (!ubicacion.estado) {
                            sucursal.ubicaciones.splice(sucursal.ubicaciones.indexOf(ubicacion), 1);
                            u--;
                            continue;
                        }
                        for (let n = 0; n < ubicacion.nodos.length; n++) {
                            let nodo = ubicacion.nodos[n];
                            if (!nodo.estado) {
                                ubicacion.nodos.splice(ubicacion.nodos.indexOf(nodo), 1);
                                n--;
                                continue;
                            }

                            sucursal.alarmaSinActividadActiva = !sucursal.alarmaSinActividadActiva ? nodo.regAlarmas.length > 0 : sucursal.alarmaSinActividadActiva;
                            sucursal.nodoMantenimiento = !sucursal.nodoMantenimiento ? nodo.mantenimiento : sucursal.nodoMantenimiento;

                            nodo.regAlarmas.forEach((regAlarma) => {
                                if (regAlarma.tipoEspecial == 'SINACTIVIDAD') {
                                    let dias =  moment().diff(moment(regAlarma.fechaActivado), "days");
                                    sucursal.tiempoAlarmaSinActividadActiva = !sucursal.tiempoAlarmaSinActividadActiva || sucursal.tiempoAlarmaSinActividadActiva < dias ? dias : sucursal.tiempoAlarmaSinActividadActiva;
                                }
                            });

                            for (let s = 0; s < nodo.sensores_id.length; s++) {
                                let sensor = nodo.sensores_id[s];
                                sensor.regAlarmas.some((regAlarma) => {
                                    if (regAlarma.tipoEspecial == 'BATERIABAJA') {
                                        sucursal.alarmaBateriaBajaActiva = true;
                                        sucursal.colorAlarmaBateriaBajaActiva == null ? sucursal.colorAlarmaBateriaBajaActiva = regAlarma.color : sucursal.colorAlarmaBateriaBajaActiva == "Amarillo" ? sucursal.colorAlarmaBateriaBajaActiva = regAlarma.color : "";
                                    } else if (regAlarma.tipoEspecial == 'SENSORNULL') {
                                        sucursal.alarmaSensorNullActivo = true;
                                        sensor.alarmaSensorNull = true;
                                    } else if (regAlarma.tipoEspecial == null) {
                                        sucursal.alarmaActiva = true;
                                        sucursal.color == null ? sucursal.color = regAlarma.color : (sucursal.color == "Amarillo" ? sucursal.color = regAlarma.color : "");
                                        sensor.color == null ? sensor.color = regAlarma.color : (sensor.color == "Amarillo" ? sensor.color = regAlarma.color : "");
                                    }
                                    return false;
                                })


                            }

                        }
                    }
                }
                setTimeout(() => {
                    $('[data-toggle="tooltip"]').tooltip({
                        animated: 'fade',
                        placement: 'left',
                        trigger: 'click'
                    });
                }, 1000);
            });

    }

    inicializarSocketAlarma() {
        //Inicilizo socket para alarmas
        this.socket.on("alarma", function (alarma: any) {
            this.recargar();
        }.bind(this));
    }

    openModal(idSucursal) {
        $("#modalGateway").modal("show");
        this.sucursales.some((sucursal) => {
            if (sucursal._id == idSucursal) {
                this.sucursalSeleccionada = sucursal;
                return true;
            }
            return false;
        });
        setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip({
                animated: 'fade',
                placement: 'left',
                trigger: 'click'
            });
        }, 1000);
    }

    cambiar(id) {
        if ($('#' + id).hasClass("in")) {
            $("#" + id + "nombre").attr('class', 'glyphicon glyphicon-plus');
            $('#' + id).collapse("hide");
        } else {
            $("#" + id + "nombre").attr('class', 'glyphicon glyphicon-minus');
            $('#' + id).collapse("show");
        }

    }

    handleChangeMostrarTodos() {
        this.mostrarTodo = !this.mostrarTodo;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/homeTecnico/homeTecnico.component.ts